export type ListStatus = "thinking" | "building" | "waiting" | "ready" | null;

export const statusFilterOrder = [
  "thinking",
  "building",
  "waiting",
  "ready",
] as const;
export type StatusFilterValue = (typeof statusFilterOrder)[number];

export const statusFilterLabels: Record<StatusFilterValue, string> = {
  thinking: "3B is thinking",
  building: "3B is building",
  waiting: "3B needs you",
  ready: "Ready",
};

export type ChatStatusData = {
  respondingAt: number | null;
  lastChatEntryType: string | null;
  awaitingAction: boolean | null;
};

type BranchData = {
  lastChatEntryAt: number | null;
  headCommitChat: ChatStatusData | null | undefined;
};

export function getChatListStatus(
  chat: ChatStatusData | null | undefined
): ListStatus {
  if (!chat?.lastChatEntryType) return null;

  const isResponding = chat.respondingAt != null;

  switch (chat.lastChatEntryType) {
    case "UserMessage":
      return isResponding ? "thinking" : null;
    case "AssistantReasoning":
      return isResponding ? "thinking" : "ready";
    case "AssistantToolUse":
      if (chat.awaitingAction) return "waiting";
      return isResponding ? "building" : "ready";
    case "AssistantMessage":
      return isResponding ? "thinking" : "ready";
    default:
      return isResponding ? "thinking" : null;
  }
}

export function getBranchListStatus(
  branch: BranchData,
  lastSeenAt?: number
): ListStatus {
  const status = getChatListStatus(branch.headCommitChat);

  if (
    status === "ready" &&
    lastSeenAt != null &&
    branch.lastChatEntryAt != null &&
    lastSeenAt >= branch.lastChatEntryAt
  ) {
    return null;
  }

  return status;
}
